import { Skeleton } from '@/components/ui/skeleton';

/** 工作流骨架屏组件 */
export const WorkflowSkeleton = () => {
  return (
    <tr className='h-[4.75rem]'>
      <td className="px-6 py-3 text-sm text-gray-700 border-t border-gray-200 w-96">
        <div className="relative w-full">
          <Skeleton className='w-[22.13rem] h-11 rounded-sm' />
        </div>
      </td>
      <td className="px-6 py-3 text-sm text-gray-700 border-t border-gray-200">
        <div className="relative w-full">
          <Skeleton className='w-full h-11 rounded-sm' />
        </div>
      </td>
    </tr>
  )
}